<template>
    <rkm-area
        title="Procedimentos"
        type="fieldset"
    >
        <ProcedimentoPrimario
            :data="data"
            ref="ProcedimentoPrincipal"
        />

        <ProcedimentoSecundario
            :data="data"
            ref="ProcedimentoSecundario"
        />

    </rkm-area>
</template>

<script>
// Components.
import ProcedimentoPrimario from './procedimento-primario/Index'
import ProcedimentoSecundario from './procedimento-secundario/Index'

export default {
    components: {
        ProcedimentoPrimario,
        ProcedimentoSecundario,
    },
    methods: {
        resetForms() {

            this.$refs.ProcedimentoPrincipal.resetForm()
            this.$refs.ProcedimentoSecundario.resetForm()
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>